import React from 'react';
import { Section } from './ui/Section';
export function PainSection() {
  return <Section background="dark" data-id="element-150">
      <div className="text-center mb-10" data-id="element-151">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-152">
          La verdad incómoda (pero liberadora)
        </h2>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-153">
          Si hoy tu casa es una tensión por pantallas, no es porque tu hijo sea
          "malo". Es porque la pantalla se volvió 4 cosas al mismo tiempo:
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10" data-id="element-154">
        {[{
        num: '1',
        title: 'Entretenimiento'
      }, {
        num: '2',
        title: 'Calmante emocional'
      }, {
        num: '3',
        title: 'Rutina'
      }, {
        num: '4',
        title: 'Premio'
      }].map(item => <div key={item.num} className="bg-[#1a2740] p-6 rounded-lg border border-[#c9a84c]/20 text-center hover:border-[#c9a84c] transition-colors" data-id="element-155">
            <span className="block text-4xl font-serif font-bold text-[#c9a84c] mb-2" data-id="element-156">
              {item.num}
            </span>
            <span className="text-gray-200 font-medium" data-id="element-157">{item.title}</span>
          </div>)}
      </div>

      <div className="bg-[#1a2740] rounded-2xl p-8 md:p-12 border-l-4 border-[#c9a84c]" data-id="element-158">
        <h3 className="text-2xl font-serif font-bold text-white mb-8" data-id="element-159">
          Por qué lo que probaste falló
        </h3>
        <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-160">
          <div className="space-y-2" data-id="element-161">
            <h4 className="text-[#c9a84c] font-bold" data-id="element-162">Prohibición abrupta</h4>
            <p className="text-gray-400" data-id="element-163">Solo crea rebote y más deseo.</p>
          </div>
          <div className="space-y-2" data-id="element-164">
            <h4 className="text-[#c9a84c] font-bold" data-id="element-165">Controles parentales</h4>
            <p className="text-gray-400" data-id="element-166">
              Generan tensión por el código, no hábitos reales.
            </p>
          </div>
          <div className="space-y-2" data-id="element-167">
            <h4 className="text-[#c9a84c] font-bold" data-id="element-168">Explicar demasiado</h4>
            <p className="text-gray-400" data-id="element-169">
              Enseña que insistir funciona y abre la negociación.
            </p>
          </div>
          <div className="space-y-2" data-id="element-170">
            <h4 className="text-[#c9a84c] font-bold" data-id="element-171">Reglas largas</h4>
            <p className="text-gray-400" data-id="element-172">
              Nadie las recuerda, nadie las cumple.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-gray-700 text-center" data-id="element-173">
          <p className="text-2xl font-serif text-white" data-id="element-174">
            No necesitas ser más duro.{' '}
            <span className="text-[#c9a84c] italic" data-id="element-175">
              Necesitas ser más claro.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}